import {
  STATUS_ERROR,
  STATUS_LOADING,
  STATUS_NOT_REQUESTED,
  STATUS_SUCCESS,
} from 'const';
import moment from 'moment';
import {
  SET_CALENDAR_MONTH_YEAR_TOGGLE,
  SET_CALENDAR_EMPLOYEE,
  CREATE_MULTIPLE_VACATIONS_SUCCESS,
  CREATE_VACATION_SUCCESS,
  DELETE_LEAVE_SUCCESS,
  EDIT_LEAVE_SUCCESS,
  GET_CALENDAR_ABSENCES_ERROR,
  GET_CALENDAR_ABSENCES_REQUEST,
  GET_CALENDAR_ABSENCES_SUCCESS,
  SET_CALENDAR_ACTIVE_BRANCH,
  SET_CALENDAR_DATE_PICKER_VALUE,
  SET_CALENDAR_WITH_ABSENCES_ONLY,
  GET_HOLIDAYS_REQUEST,
  GET_HOLIDAYS_SUCCESS,
  GET_HOLIDAYS_ERROR,
  GET_ABSENCES_TYPES_SUCCESS,
  CREATE_VACATION_REQUEST_ERROR,
  SET_CALENDAR_PAGE_PAGINATION,
  SET_CALENDAR_PAGE,
} from 'modules/SalaryModule/Calendar/actions';
import {
  EDIT_LEAVE_REQUEST,
  CREATE_VACATION_REQUEST,
} from 'modules/SalaryModule/Vacations/actions';

import { HOMEPAGE_FORM_TRANSLATIONS } from 'const/translations';
const { MONTH } = HOMEPAGE_FORM_TRANSLATIONS.YEAR_MONTH_SWITCH;

const initialState = {
  monthYearToggle: MONTH,
  calendarEmployee: undefined,
  absences: [],
  absencesStatus: STATUS_NOT_REQUESTED,
  absencesError: {},
  error: {},
  dateFilter: moment().startOf('month'),
  branchFilter: '',
  withAbsencesOnly: false,
  areHolidaysUpdating: false,
  yearsWithoutHolidays: [],
  absencesTypes: [],
  // pagination
  currentPage: 1,
  pages: 0,
  limit: 20,
  total: 0,
};

export const calendarReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CALENDAR_MONTH_YEAR_TOGGLE:
      return {
        ...state,
        monthYearToggle: action.payload.value,
      };

    case SET_CALENDAR_EMPLOYEE:
      return {
        ...state,
        calendarEmployee: action.payload.value,
      };

    case SET_CALENDAR_ACTIVE_BRANCH:
      return {
        ...state,
        branchFilter: action.payload.branchId,
        calendarEmployee: undefined,
      };

    case SET_CALENDAR_DATE_PICKER_VALUE:
      return {
        ...state,
        dateFilter: action.payload.date,
        absencesStatus: STATUS_LOADING,
      };

    case SET_CALENDAR_WITH_ABSENCES_ONLY:
      return {
        ...state,
        withAbsencesOnly: action.payload.value,
      };

    case EDIT_LEAVE_REQUEST:
      return {
        ...state,
        absences: state.absences.map((absence) =>
          absence.id === action.payload.leaveObj.id
            ? action.payload.leaveObj
            : absence
        ),
      };

    case CREATE_VACATION_REQUEST: {
      const supportingDoc = action.payload.file
        ? { name: action.payload.file.name }
        : {};
      return {
        ...state,
        absences: [
          ...state.absences,
          {
            ...action.payload.data,
            employeeId: action.payload.employeeId,
            supportingDoc,
          },
        ],
      };
    }

    case CREATE_VACATION_REQUEST_ERROR:
      return {
        ...state,
        absences: state.absences.filter((el) => el.id),
      };

    case EDIT_LEAVE_SUCCESS:
      return {
        ...state,
        absences: state.absences.map((absence) =>
          absence.id === action.payload.leaveObj.id &&
          absence.employeeId === action.payload.leaveObj.employeeId
            ? { ...absence, ...action.payload.leaveObj }
            : absence
        ),
      };

    case CREATE_VACATION_SUCCESS: {
      const { leaveObj } = action.payload;

      const { absence: newAbsence, absences: newAbsences } = leaveObj || {};

      let updatedAbsences = [...state.absences.filter((absence) => absence.id)];

      if (newAbsence) {
        updatedAbsences = [...updatedAbsences, newAbsence];
      }

      if (newAbsences?.length) {
        updatedAbsences = [...updatedAbsences, ...newAbsences];
      }

      return {
        ...state,
        absences: updatedAbsences,
      };
    }

    case CREATE_MULTIPLE_VACATIONS_SUCCESS:
      return {
        ...state,
        absences: [...state.absences, ...action.payload.leaveObjArray],
      };

    case DELETE_LEAVE_SUCCESS:
      return {
        ...state,
        absences: state.absences.filter(
          (absence) => absence.id !== action.payload.absenceId
        ),
      };

    case GET_CALENDAR_ABSENCES_REQUEST:
      return {
        ...state,
        absencesStatus: STATUS_LOADING,
      };

    case GET_CALENDAR_ABSENCES_SUCCESS:
      return {
        ...state,
        absences: action.payload.data.absences,
        absencesStatus: STATUS_SUCCESS,
      };

    case GET_CALENDAR_ABSENCES_ERROR:
      return {
        ...state,
        absencesStatus: STATUS_ERROR,
        absences: initialState.absences,
        absencesError: action.payload.error,
      };

    case GET_HOLIDAYS_REQUEST:
      return {
        ...state,
        areHolidaysUpdating: true,
      };

    case GET_HOLIDAYS_SUCCESS:
      return {
        ...state,
        areHolidaysUpdating: false,
      };

    case GET_HOLIDAYS_ERROR:
      return {
        ...state,
        areHolidaysUpdating: false,
        yearsWithoutHolidays: {
          ...state.yearsWithoutHolidays,
          ...action.payload,
        },
      };

    case GET_ABSENCES_TYPES_SUCCESS:
      return {
        ...state,
        absencesTypes: action.payload,
      };

    case SET_CALENDAR_PAGE_PAGINATION: {
      const { page, pages, limit, total } = action.payload;

      return {
        ...state,
        currentPage: page,
        pages,
        limit,
        total,
      };
    }

    case SET_CALENDAR_PAGE:
      return {
        ...state,
        currentPage: action.payload,
      };

    default:
      return state;
  }
};
